// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationOutlinedSvg from "@ant-design/icons-svg/es/asn/FileExclamationOutlined";
import AntdIcon from '../components/AntdIcon';

var FileExclamationOutlined = function FileExclamationOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationOutlinedSvg
  }));
};

FileExclamationOutlined.displayName = 'FileExclamationOutlined';
export default React.forwardRef(FileExclamationOutlined);